// extracted by mini-css-extract-plugin
export var tosLink = "_46-0";